<div class="text-logo-container" *ngIf="lottie">
    <span id="{{id}}" *ngIf="a11yText" class="text" [innerHTML]="a11yText | safeHtml"></span>
    @defer {
        <finder-lottie [attr.aria-labelledby]="id" class="logo" [data]="lottie"></finder-lottie>
    }
</div>
